var _circle, _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccessProfileIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 140,
    viewBox: "0 0 141 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 69.4347,
    cy: 79.6852,
    r: 53.3141,
    fill: "url(#paint0_linear_1898_165949)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.4348 35.1025C44.8117 35.1025 24.8507 55.0635 24.8507 79.6865C24.8507 104.31 44.8117 124.271 69.4348 124.271C94.0579 124.271 114.019 104.31 114.019 79.6865C114.019 55.0635 94.0579 35.1025 69.4348 35.1025ZM22.9123 79.6865C22.9123 53.9929 43.7411 33.1641 69.4348 33.1641C95.1284 33.1641 115.957 53.9929 115.957 79.6865C115.957 105.38 95.1284 126.209 69.4348 126.209C43.7411 126.209 22.9123 105.38 22.9123 79.6865Z",
    fill: "url(#paint1_linear_1898_165949)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.3339 76.1708L69.7056 87.5424L91.8396 65.4085L99.7469 73.3158L69.7056 103.357L50.4266 84.0781L58.3339 76.1708Z",
    fill: "url(#paint2_linear_1898_165949)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.1707 68.6527L67.8436 80.3256L90.5638 57.6053L98.6807 65.7221L67.8436 96.5593L48.0538 76.7695L56.1707 68.6527Z",
    fill: "#3EE78D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M131.238 29.0898L133.531 35.2864L139.728 37.5793L133.531 39.8723L131.238 46.0688L128.945 39.8723L122.749 37.5793L128.945 35.2864L131.238 29.0898Z",
    fill: "#3EE78D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M118.49 8L121.889 17.1863L131.075 20.5856L121.889 23.9848L118.49 33.1711L115.09 23.9848L105.904 20.5856L115.09 17.1863L118.49 8Z",
    fill: "#3EE78D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.95202 54.2168L8.69465 58.9262L13.404 60.6688L8.69465 62.4115L6.95202 67.1208L5.20939 62.4115L0.5 60.6688L5.20939 58.9262L6.95202 54.2168Z",
    fill: "#3EE78D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1898_165949",
    x1: 53.3538,
    y1: 18.7783,
    x2: 53.3538,
    y2: 151.731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C2582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94793,
    stopColor: "#213DA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1898_165949",
    x1: 50.5638,
    y1: 257.072,
    x2: 53.4603,
    y2: -35.9429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.211119,
    stopColor: "#0C2894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895928,
    stopColor: "#5877EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1898_165949",
    x1: 105.748,
    y1: 121.544,
    x2: 45.417,
    y2: 60.4426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.211119,
    stopColor: "#0C2894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895928,
    stopColor: "#5877EC"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessProfileIcon);
export default __webpack_public_path__ + "static/media/success-profile-icon.3475484fb402991a129a2dab223abbeb.svg";
export { ForwardRef as ReactComponent };